<template>
    <div class="p-5">
        <div class="d-flex justify-content-between align-items-center mb-5">
            <div class="c-title">Designations</div>

            <button
                v-if="DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.DESIGNATION_ADD)"
                class="btn c-btn-add" @click="addItem">
                <i class="fa fa-plus" aria-hidden="true"></i>
            </button>
        </div>

        <div class="table-responsive">
            <table class="table">
                <thead class="c-thead">
                <tr>
                    <th scope="col" class="h-name">
                        Designation Name
                    </th>
                    <th scope="col" class="h-name">Designation ID</th>
                    <th scope="col" class="h-name">External Code</th>
                    <th scope="col" class="h-name"></th>
                </tr>
                </thead>
                <tbody v-if="items.length">
                <tr v-for="data in items"
                    v-bind:key="data.designation_id"
                    class="c-tr" style="cursor: pointer">
                    <td @click="updateItem(data)">{{ data.name }}</td>
                    <td @click="updateItem(data)">{{ data.designation_id }}</td>
                    <td @click="updateItem(data)">{{
                            data.external_code || '---'
                        }}
                    </td>
                    <td>
                        <div v-if="data.can_delete">
                            <a v-if="DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.DESIGNATION_EDIT)" href="javascript:;" class=""
                               @click="removeItem(data)">
                                <img src="@/assets/images/trash.svg"/>
                            </a>
                        </div>
                        <button v-else-if="DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.DESIGNATION_DONATION)" class="btn btn-sm c-donations-btn"
                                @click="gotoDonations(data)">Donations
                        </button>
                    </td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                    <td colspan="6" class="text-center">No data</td>
                </tr>
                </tbody>
            </table>
            <div class="d-flex justify-content-center" v-if="totalPage > 1">
                <CustomPagination :activePage="currentPage"
                                  :totalPage="totalPage"
                                  @paginationHandle="onClickPagging"></CustomPagination>
            </div>

            <modal-designation-form
                :data="modalData"
                v-if="isShowAddEditModal"
                @close="isShowAddEditModal = false"
                @success="formSuccess"
            />
        </div>
    </div>
</template>

<script>
import DibbleJs from '@/dibble';
import DibbleApi from '@/api';
import CustomPagination from "@/commons/CustomPagination/CustomPagination.vue";
import {EventBus} from "@/utils/event-bus";
import ModalDesignationForm
    from "@/components/Designations/ModalDesignationForm.vue";
import DibbleJS from "@/dibble";
import Authorizations from "@/utils/authorizations";

export default {
    name: 'CampaignQuestions',
    computed: {
        Authorizations() {
            return Authorizations
        },
        DibbleJS() {
            return DibbleJS
        }
    },
    components: {
        CustomPagination,
        ModalDesignationForm,
    },
    data() {
        return {
            search: '',
            items: [],
            totalPage: 0,
            currentPage: 1,
            isShowAddEditModal: false,
            modalData: null,
        };
    },
    methods: {
        getDesignations(page = 0) {
            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.designationGetAll,
                search_string: this.search,
                page,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    if (page === 0) {
                        this.totalPage = response.num_of_pages;
                        this.currentPage = 1;
                    }
                    this.items = response.designations;
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        onClickPagging(page) {
            this.currentPage = page.pageIndex;
            this.getDesignations(page.pageIndex - 1);
        },
        addItem() {
            this.modalData = null;
            this.isShowAddEditModal = true;
        },
        updateItem(data) {
            if (!DibbleJs.isAllowedAccess(Authorizations.MODULE_NAMES.DESIGNATION_EDIT)) {
                return;
            }
            this.modalData = data;
            this.isShowAddEditModal = true;
        },
        removeItem(data) {
            DibbleJs.showLoader();
            const dataRequest = {
                '#request': DibbleApi.api.designationDelete,
                designation_id: data.designation_id,
            };
            DibbleJs.callApiRequest(dataRequest, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    DibbleJs.toastSuccessMessage('Designation has been deleted');
                    this.currentPage = 1;
                    this.getDesignations();
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        formSuccess() {
            this.isShowAddEditModal = false;
            this.currentPage = 1;
            this.getDesignations();
        },
        gotoDonations(data) {
            this.$router.push({
                name: 'DesignationDonations',
                params: {
                    id: data.designation_id,
                    name: data.name,
                },
            });
        }
    },
    created() {
        this.getDesignations();
        EventBus.$on('searchDesignations', (search) => {
            this.search = search;
            this.getDesignations();
        });
    },
};
</script>

<style lang="scss" scoped>
.c-cancel-btn {
    border-radius: 20px;
    background: #d9d9d9;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    font-size: 20px;
    font-weight: 700;
    width: 120px;
    color: #555e67;
    line-height: 140%;
}

.c-title {
    color: #2178ab;
    font-size: 22px;
    font-weight: 700;
}

.c-tab-list {
    border-radius: 20px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
}

.c-btn-add {
    color: #fff;
    width: 61px;
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #2178ab;
    border-radius: 20px;
    font-size: 24px;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
}

.c-thead {
    th {
        color: #41B8DC;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;

        &.h-name {
            width: 25%;
        }

        &.h-phone {
            width: 15%;
        }

        &.h-email {
            width: 20%;
        }

        &.h-date {
            width: 20%;
        }

        &.h-amount {
            width: 20%;
        }
    }
}

td {
    vertical-align: middle;
}

.c-donations-btn {
    border-radius: 20px;
    background: #6CA779;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    font-size: 20px;
    font-weight: 700;
    width: 140px;
    color: #fff;
    line-height: 140%;

    &.btn-sm {
        width: 120px;
        font-size: 16px;
    }
}
</style>
